<template>
  <div class="modal-window" style="padding-bottom: 40px; overflow: scroll">
    <w-form>
      <w-form-item v-if="type != 'zg'" label="忽略说明" label-width="120px">
        <w-input
          v-model="HLSM"
          type="textarea"
          placeholder=""
          :readonly="readonly"
          :rows="4"
        ></w-input>
      </w-form-item>
      <w-form-item
        :label="type == 'zg' ? '整改附件' : '忽略附件'"
        label-width="120px"
      >
        <w-upload
          v-if="!readonly"
          class="upload-demo"
          action=""
          accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.jpg,.png,.bmp,.txt"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :http-request="uploadFile"
          :show-file-list="false"
          :limit="5"
          :disabled="uploadedFile.length >= 5"
          :file-list="fileList"
        >
          <w-button size="small" icon="w-icon-upload" type="primary">
            点击上传
          </w-button>
          <div slot="tip" class="w-upload__tip" style="color: ">
            <div>
              文件类型支持：pdf、jpg、png、bmp、txt、doc、docx、xls、xlsx、ppt、pptx
            </div>
            <w-link
              v-show="uploadedFile.length >= 5"
              :underline="false"
              type="warning"
            >
              最多只能上传5个文件
            </w-link>
          </div>
        </w-upload>

        <div v-if="uploadedFile.length > 0" class="file">
          <div style="color: rgb(181 181 181)">
            下方为已上传附件,共{{
              uploadedFile.length
            }}个(点击文件右侧按钮进行删除)
          </div>
          <div
            v-for="(item, index) in uploadedFile"
            :key="item.id"
            class="file-item"
          >
            <w-image
              v-if="item.type == 'image'"
              class="file-item-icon"
              style="width: 80px; height: 80px"
              :src="item.url"
              :preview-src-list="[item.url]"
            >
            </w-image>
            <div
              v-else-if="item.type == 'pdf'"
              class="w-icon-pdf2 file-item-icon"
            ></div>
            <div
              v-else-if="item.type == 'excel'"
              class="w-icon-excel file-item-icon"
            ></div>
            <div
              v-else-if="item.type == 'word'"
              class="w-icon-word file-item-icon"
            ></div>
            <div v-else class="w-icon-file file-item-icon"></div>
            <w-link type="primary" :href="item.url" target="_blank">
              {{ item.name }}
            </w-link>
            <i
              v-if="!readonly"
              class="w-icon-delete remove"
              @click.stop="remove(item)"
            ></i>
            <i class="number">{{ index + 1 }}</i>
          </div>
        </div>
      </w-form-item>
    </w-form>

    <div v-if="!readonly" class="modal-window-footer" style="z-index: 99999">
      <div class="window-footer-btns">
        <w-button @click="exit()"> 取消 </w-button>
        <w-button type="primary" @click="ignore()"> 确认 </w-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'IgnoreZG',
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    WTXH: {
      type: String,
      default: () => ''
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    type: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      HLSM: '',
      fileList: [],
      uploadedFile: [] // 已经上传的文件，用于展示或者下载查看
    }
  },
  mounted() {
    this.getIgnoreInfo()
    this.uploadedFile = new Array()
  },
  methods: {
    getIgnoreInfo() {
      let that = this
      this.$requestApi('GetIgnoreWTInfo', {
        wtxhs: this.WTXH,
        HLSM: this.HLSM,
        type: this.type
      }).then((res) => {
        if (res.success && res.data) {
          this.HLSM = res.data[0].HLSM
          this.uploadedFile = res.data[0].fileList.map((m) => {
            return {
              id: m.id,
              name: m.name,
              url: m.url,
              type: that.getfileType(m.name)
            }
          })
        } else {
          this.uploadedFile = new Array()
        }
      })
    },
    ignore() {
      // this.$Confirm('是否忽略整改', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      //   .then((res) => {
      this.$requestApi('IgnoreWT', {
        wtxhs: this.WTXH,
        HLSM: this.HLSM
      }).then((res) => {
        if (res.success) {
          this.$msg('忽略成功！', 'success')
          this.$emit('close', { type: true })
        }
      })
      // })
      // .catch(() => {})
    },
    exit() {
      this.$emit('close', { type: false })
    },
    // 上传
    uploadFile(file) {
      let that = this
      let fd = new FormData()
      let userInfo = this.$store.state.user.loginUserInfo
      fd.append('file', file.file)
      fd.append('REFNO', this.WTXH)
      fd.append('ATTACHTYPE', 'WTIgnore')
      fd.append('UserId', userInfo.UserId)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      axios
        .post(`${window.globalConfig.BaseUrl}NQCS/UploadFile`, fd, config)
        .then((res) => {
          if (!res.data.success) {
            this.$message({
              message: res.data.message,
              customClass: 'close-msg'
            })
            var el = document.querySelector('.close-msg')
            if (el) el.style.cssText = 'z-index: 9999'
          } else {
            let obj = {}
            obj.id = res.data.data.id
            obj.name = file.file.name
            obj.url = res.data.data.url
            obj.type = that.getfileType(obj.name)

            this.uploadedFile.push(obj)
          }
        })
        .catch((error) => {
          this.$message(error)
        })
    },
    beforeRemove(file, fileList) {},
    // 删除问题关联的上传文件
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    view(file) {},
    remove(file) {
      let that = this
      this.$Confirm(`是否删除关联的文件【${file.name}】`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then((res) => {
          this.$requestApi('RemoveAttach', {
            id: file.id
          }).then((res) => {
            if (res.success) {
              that.$msg('删除成功！', 'success')

              let index = that.uploadedFile.findIndex((m) => m.id == file.id)
              if (index > -1) {
                that.uploadedFile.splice(index, 1)
              }
            }
          })
        })
        .catch(() => {})
    },
    getfileType(name) {
      if (name.indexOf('.txt') > -1) {
        return 'txt'
      }
      if (
        name.indexOf('.png') > -1 ||
        name.indexOf('.jpg') > -1 ||
        name.indexOf('.bmp') > -1
      ) {
        return 'image'
      }
      if (name.indexOf('.xls') > -1 || name.indexOf('.xlsx') > -1) {
        return 'excel'
      }
      if (name.indexOf('.pdf') > -1) {
        return 'pdf'
      }
      if (name.indexOf('.ppt') > -1 || name.indexOf('.pptx') > -1) {
        return 'ppt'
      }
      if (name.indexOf('.doc') > -1 || name.indexOf('.docx') > -1) {
        return 'word'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.image-view {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  &-item {
    background-color: white;
    flex: 0 0 100px;
    width: 100px;
    height: 100px;
    margin: 10px;
    cursor: pointer;
  }
}

.file {
  width: 100%;
  .file-item {
    cursor: pointer;
    margin: 5px 0;
    width: 100%;
    height: 100px;
    padding: 10px 20px 10px;
    border: 1px solid #e3e3e3;
    border-radius: 2px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &-icon {
      font-size: 48px;
      margin-right: 5px;
    }
    .remove {
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 24px;
      &:hover {
        background-color: #e3e3e3;
      }
    }
    .number {
      position: absolute;
      left: 1px;
      top: 5px;
    }
  }
}
</style>
